<template>
  <div class="chart-box">
    <!--    <div v-if="Object.keys(report).length === 0" class="loader"></div>-->
    <div class="loader-div" v-if="Object.keys(report).length === 0">
      <span class="insteadLoader"
        >GENERATING REPORT ,PLEASE WAIT
        <div class="snippet" data-title=".dot-flashing">
          <div class="stage">
            <div class="dot-flashing"></div>
          </div>
        </div>
      </span>
    </div>

    <div class="report-options" v-if="Object.keys(report).length > 0">
      <span class="filter-buttons">
        <div>
          <input
            class="filter"
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="reg"
            value="REG"
            checked
          />
          <label class="filter-title" for="reg">REG</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="dup"
            value="DUP"
          />
          <label class="filter-title" for="dup">DUP</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="all"
            value="ALL"
          />
          <label class="filter-title" for="all">ALL</label>
        </div>
      </span>
      <div class="report-calendar-cm">
        <date-picker
          lang="en"
          inline
          :disabled-date="notAfterToday"
          :get-classes="getClasses"
          v-model="reportDate"
          @input="getReportByDate"
        ></date-picker>
      </div>
    </div>
    <div class="report-data" v-if="Object.keys(report).length > 0">
      <ul class="main-tabs">
        <li
          class="daily-stats-tabs"
          v-if="
            report[tab.alias] &&
              report[tab.alias]['all_data'] &&
              (report[tab.alias]['all_data'][filterOption].length > 0 ||
                !Array.isArray(report[tab.alias]['all_data'][filterOption]))
          "
          v-for="tab in statsTabs"
          :key="tab.id"
          :class="{ active: selectedStatsTab === tab.alias }"
          @click="selectedStatsTab = tab.alias"
        >
          <span>
            {{ tab.name }}
          </span>
          <span
            class="stats-tabs-numbers"
            v-if="report[tab.alias]['all_data'][filterOption].length === 0"
          >
            0
          </span>
          <span v-else class="stats-tabs-numbers">
            <span
              v-if="Array.isArray(report[tab.alias]['all_data'][filterOption])"
            >
              {{
                report[tab.alias]["all_data"][filterOption][0]
                  .total_in_time_frame
              }}
            </span>
            <span v-else>
              <span v-if="tab.alias == 'cc_decline_deposits'">
                {{
                  report[tab.alias]["all_data"][filterOption]
                    .total_deposits_in_time_frame
                }}
              </span>
              <span v-else>
                {{
                  report[tab.alias]["all_data"][filterOption]
                    .total_in_time_frame
                }}
              </span>
            </span>
          </span>
        </li>
      </ul>
      <!--      <div-->
      <!--        class="daily-report-tab"-->
      <!--        v-if="-->
      <!--          selectedStatsTab === 'assigned_agents' &&-->
      <!--            Object.keys(report).length > 0 &&-->
      <!--            report['assigned_agents']['all_data'][filterOption] &&-->
      <!--            report['assigned_agents']['all_data'][filterOption].length > 0-->
      <!--        "-->
      <!--      >-->
      <!--        <span-->
      <!--          v-for="(value, key) in report['assigned_agents']['all_data'][filterOption]"-->
      <!--          :key="key"-->
      <!--          class="top-stat-title"-->
      <!--        >-->
      <!--          {{-->
      <!--            salesPersonList.find(-->
      <!--              item =>-->
      <!--                item.id === report["assigned_agents"]['all_data'][filterOption][key].id-->
      <!--            ).full_name-->
      <!--          }}-->
      <!--          | {{ report["assigned_agents"]['all_data'][filterOption][key].total }} |-->
      <!--          {{ report["assigned_agents"]['all_data'][filterOption][key].total_in_time_frame }}-->
      <!--          |-->
      <!--          {{-->
      <!--            (-->
      <!--              (100 * report["assigned_agents"]['all_data'][filterOption][key].total) /-->
      <!--              report["assigned_agents"]['all_data'][filterOption][key].total_in_time_frame-->
      <!--            ).toFixed(1)-->
      <!--          }}%-->
      <!--          <br />-->
      <!--          <span-->
      <!--            class="report-rank"-->
      <!--            v-for="rank in report['assigned_agents']['all_data'][filterOption][key]-->
      <!--              .rankings"-->
      <!--            :key="rank"-->
      <!--            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--          >-->
      <!--            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--              {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--            </span>-->
      <!--          </span>-->
      <!--        </span>-->
      <!--              <table-->
      <!--                v-if="-->
      <!--                  Object.keys(report).length > 0 &&-->
      <!--                    report['assigned_agents'] &&-->
      <!--                    report['assigned_agents'].length > 0-->
      <!--                "-->
      <!--              >-->
      <!--                <tbody>-->
      <!--                  <tr>-->
      <!--                    <td-->
      <!--                      v-for="cond in report['assigned_agents'][0].campaign_aaid"-->
      <!--                      :key="cond.id"-->
      <!--                    >-->
      <!--                      <span-->
      <!--                        >{{ cond.id }} <br />-->
      <!--                        {{ cond.amount }} |-->
      <!--                        {{ report["assigned_agents"][0].total_in_time_frame }} |-->
      <!--                        {{-->
      <!--                          (-->
      <!--                            (100 * cond.amount) /-->
      <!--                            report["assigned_agents"][0].total_in_time_frame-->
      <!--                          ).toFixed(1)-->
      <!--                        }}% |-->
      <!--                        {{-->
      <!--                          (-->
      <!--                            (100 * cond.amount) /-->
      <!--                            report["assigned_agents"][0].total-->
      <!--                          ).toFixed(1)-->
      <!--                        }}% |</span-->
      <!--                      >-->
      <!--                      <span-->
      <!--                        class="report-rank"-->
      <!--                        v-for="rank in cond.rankings"-->
      <!--                        :key="rank"-->
      <!--                        v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--                      >-->
      <!--                        <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--                          {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--                        </span>-->
      <!--                      </span>-->
      <!--                    </td>-->
      <!--                  </tr>-->
      <!--                  <tr>-->
      <!--                    <td-->
      <!--                      v-for="cond in report['assigned_agents'][0].country_id"-->
      <!--                      :key="cond.id"-->
      <!--                    >-->
      <!--                      <span-->
      <!--                        >{{-->
      <!--                          dictionaries.general.countries.find(-->
      <!--                            country => country.id === cond.id-->
      <!--                          ).name-->
      <!--                        }}-->
      <!--                        <br />-->
      <!--                        {{ cond.amount }} |-->
      <!--                        {{ report["assigned_agents"][0].total_in_time_frame }} |-->
      <!--                        {{-->
      <!--                          (-->
      <!--                            (100 * cond.amount) /-->
      <!--                            report["assigned_agents"][0].total_in_time_frame-->
      <!--                          ).toFixed(1)-->
      <!--                        }}% |-->
      <!--                        {{-->
      <!--                          (-->
      <!--                            (100 * cond.amount) /-->
      <!--                            report["assigned_agents"][0].total-->
      <!--                          ).toFixed(1)-->
      <!--                        }}% |</span-->
      <!--                      >-->
      <!--                      <span-->
      <!--                        class="report-rank"-->
      <!--                        v-for="rank in cond.rankings"-->
      <!--                        :key="rank"-->
      <!--                        v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--                      >-->
      <!--                        <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--                          {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--                        </span>-->
      <!--                      </span>-->
      <!--                    </td>-->
      <!--                  </tr>-->
      <!--                  <tr>-->
      <!--                    <td-->
      <!--                      v-for="cond in report['assigned_agents'][0].keyword"-->
      <!--                      :key="cond.id"-->
      <!--                    >-->
      <!--                      <span-->
      <!--                        >{{ cond.id }} <br />-->
      <!--                        {{ cond.amount }} |-->
      <!--                        {{ report["assigned_agents"][0].total_in_time_frame }} |-->
      <!--                        {{-->
      <!--                          (-->
      <!--                            (100 * cond.amount) /-->
      <!--                            report["assigned_agents"][0].total_in_time_frame-->
      <!--                          ).toFixed(1)-->
      <!--                        }}% |-->
      <!--                        {{-->
      <!--                          (-->
      <!--                            (100 * cond.amount) /-->
      <!--                            report["assigned_agents"][0].total-->
      <!--                          ).toFixed(1)-->
      <!--                        }}% |</span-->
      <!--                      >-->
      <!--                      <span-->
      <!--                        class="report-rank"-->
      <!--                        v-for="rank in cond.rankings"-->
      <!--                        :key="rank"-->
      <!--                        v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--                      >-->
      <!--                        <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--                          {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--                        </span>-->
      <!--                      </span>-->
      <!--                    </td>-->
      <!--                  </tr>-->
      <!--                </tbody>-->
      <!--              </table>-->
      <!--      </div>-->
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'bad_number_reasons' &&
            Object.keys(report).length > 0 &&
            report['bad_number_reasons'] &&
            report['bad_number_reasons']['all_data'][filterOption] &&
            report['bad_number_reasons']['all_data'][filterOption].length > 0
        "
      >
        <span
          v-for="(value, key) in report['bad_number_reasons']['all_data'][
            filterOption
          ].slice(0, 3)"
          :key="key"
          class="top-stat-title"
          v-if="
            dictionaries.activity.bad_number_states.find(
              item =>
                item.id ===
                report['bad_number_reasons']['all_data'][filterOption][key].id
            )
          "
        >
          {{
            dictionaries.activity.bad_number_states.find(
              item =>
                item.id ===
                report["bad_number_reasons"]["all_data"][filterOption][key].id
            ).name
          }}
          |
          {{
            report["bad_number_reasons"]["all_data"][filterOption][key].total
          }}
          |
          <!--          {{-->
          <!--            report["bad_number_reasons"]['all_data'][filterOption][key].total_in_time_frame-->
          <!--          }}-->
          <!--          |-->
          {{
            (
              (100 *
                report["bad_number_reasons"]["all_data"][filterOption][key]
                  .total) /
              report["bad_number_reasons"]["all_data"][filterOption][key]
                .total_in_time_frame
            ).toFixed(1)
          }}%
          <br />
          <span
            class="report-rank"
            v-for="rank in report['bad_number_reasons']['all_data'][
              filterOption
            ][key].rankings"
            :key="rank"
            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
          >
            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
              {{ rank["id"] }}:{{ rank["rank"] }}|
            </span>
          </span>
        </span>
        <!--      <table-->
        <!--        v-if="-->
        <!--          Object.keys(report).length > 0 &&-->
        <!--            report['bad_number_reasons'] &&-->
        <!--            report['bad_number_reasons'].length > 0-->
        <!--        "-->
        <!--      >-->
        <!--        <tbody>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['bad_number_reasons'][0].users"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span>-->
        <!--                {{-->
        <!--                  salesPersonList.find(item => item.id === cond.id).full_name-->
        <!--                }}-->
        <!--                <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["bad_number_reasons"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["bad_number_reasons"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["bad_number_reasons"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--              </span>-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['bad_number_reasons'][0].campaign_aaid"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["bad_number_reasons"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["bad_number_reasons"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["bad_number_reasons"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['bad_number_reasons'][0].country_id"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{-->
        <!--                  dictionaries.general.countries.find(-->
        <!--                    country => country.id === cond.id-->
        <!--                  ).name-->
        <!--                }}-->
        <!--                <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["bad_number_reasons"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["bad_number_reasons"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["bad_number_reasons"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['bad_number_reasons'][0].keyword"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["bad_number_reasons"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["bad_number_reasons"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["bad_number_reasons"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--        </tbody>-->
        <!--      </table>-->
      </div>
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'brokers' &&
            Object.keys(report).length > 0 &&
            report['brokers'] &&
            report['brokers']['all_data'][filterOption] &&
            report['brokers']['all_data'][filterOption].length > 0
        "
      >
        <span
          v-for="(value, key) in report['brokers']['all_data'][
            filterOption
          ].slice(0, 3)"
          :key="key"
          class="top-stat-title"
          v-if="
            dictionaries.general.brokers.find(
              item =>
                item.id === report['brokers']['all_data'][filterOption][key].id
            )
          "
        >
          {{
            dictionaries.general.brokers.find(
              item =>
                item.id === report["brokers"]["all_data"][filterOption][key].id
            ).name
          }}
          | {{ report["brokers"]["all_data"][filterOption][key].total }} |
          <!--          {{ report["brokers"]['all_data'][filterOption][key].total_in_time_frame }} |-->
          {{
            (
              (100 * report["brokers"]["all_data"][filterOption][key].total) /
              report["brokers"]["all_data"][filterOption][key]
                .total_in_time_frame
            ).toFixed(1)
          }}%
          <br />
          <span
            class="report-rank"
            v-for="rank in report['brokers']['all_data'][filterOption][key]
              .rankings"
            :key="rank"
            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
          >
            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
              {{ rank["id"] }}:{{ rank["rank"] }}|
            </span>
          </span>
        </span>
        <!--      <table>-->
        <!--        <tbody>-->
        <!--          <tr>-->
        <!--            <td v-for="cond in report['brokers'][0].users" :key="cond.id">-->
        <!--              {{ salesPersonList.find(item => item.id === cond.id).full_name }}-->
        <!--              <br />-->
        <!--              {{ cond.amount }} |-->
        <!--              {{ report["brokers"][0].total_in_time_frame }} |-->
        <!--              {{-->
        <!--                (-->
        <!--                  (100 * cond.amount) /-->
        <!--                  report["brokers"][0].total_in_time_frame-->
        <!--                ).toFixed(1)-->
        <!--              }}% |-->
        <!--              {{-->
        <!--                ((100 * cond.amount) / report["brokers"][0].total).toFixed(1)-->
        <!--              }}% |-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['brokers'][0].campaign_aaid"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["brokers"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["brokers"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  ((100 * cond.amount) / report["brokers"][0].total).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td v-for="cond in report['brokers'][0].keyword" :key="cond.id">-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["brokers"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["brokers"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  ((100 * cond.amount) / report["brokers"][0].total).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td v-for="cond in report['brokers'][0].country_id" :key="cond.id">-->
        <!--              <span-->
        <!--                >{{-->
        <!--                  dictionaries.general.countries.find(-->
        <!--                    country => country.id === cond.id-->
        <!--                  ).name-->
        <!--                }}-->
        <!--                <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["brokers"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["brokers"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  ((100 * cond.amount) / report["brokers"][0].total).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--        </tbody>-->
        <!--      </table>-->
      </div>
      <!--      <div-->
      <!--        class="daily-report-tab"-->
      <!--        v-if="-->
      <!--          selectedStatsTab === 'campaigns' &&-->
      <!--            Object.keys(report).length > 0 &&-->
      <!--            report['campaigns']['all_data'][filterOption] &&-->
      <!--            report['campaigns']['all_data'][filterOption].length > 0-->
      <!--        "-->
      <!--      >-->
      <!--        <span-->
      <!--          v-for="(value, key) in report['campaigns']['all_data'][filterOption]"-->
      <!--          :key="key"-->
      <!--          class="top-stat-title"-->
      <!--        >-->
      <!--          {{ report["campaigns"]['all_data'][filterOption][key].id }} |-->
      <!--          {{ report["campaigns"]['all_data'][filterOption][key].total }} |-->
      <!--          {{ report["campaigns"]['all_data'][filterOption][key].total_in_time_frame }} |-->
      <!--          {{-->
      <!--            (-->
      <!--              (100 * report["campaigns"]['all_data'][filterOption][key].total) /-->
      <!--              report["campaigns"]['all_data'][filterOption][key].total_in_time_frame-->
      <!--            ).toFixed(1)-->
      <!--          }}%-->
      <!--          <br />-->
      <!--          <span-->
      <!--            class="report-rank"-->
      <!--            v-for="rank in report['campaigns']['all_data'][filterOption][key].rankings"-->
      <!--            :key="rank"-->
      <!--            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--          >-->
      <!--            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--              {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--            </span>-->
      <!--          </span>-->
      <!--        </span>-->
      <!--              <table-->
      <!--                v-if="-->
      <!--                  Object.keys(report).length > 0 &&-->
      <!--                    report['campaigns'] &&-->
      <!--                    report['campaigns'].length > 0-->
      <!--                "-->
      <!--              >-->
      <!--                <tbody>-->
      <!--                  <tr>-->
      <!--                    <td v-for="cond in report['campaigns'][0].users" :key="cond.id">-->
      <!--                      {{ salesPersonList.find(item => item.id === cond.id).full_name }}-->
      <!--                      <br />-->
      <!--                      {{ cond.amount }} |-->
      <!--                      {{ report["campaigns"][0].total_in_time_frame }} |-->
      <!--                      {{-->
      <!--                        (-->
      <!--                          (100 * cond.amount) /-->
      <!--                          report["campaigns"][0].total_in_time_frame-->
      <!--                        ).toFixed(1)-->
      <!--                      }}% |-->
      <!--                      {{-->
      <!--                        ((100 * cond.amount) / report["campaigns"][0].total).toFixed(1)-->
      <!--                      }}% |-->
      <!--                      <span-->
      <!--                        class="report-rank"-->
      <!--                        v-for="rank in cond.rankings"-->
      <!--                        :key="rank"-->
      <!--                        v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--                      >-->
      <!--                        <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--                          {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--                        </span>-->
      <!--                      </span>-->
      <!--                    </td>-->
      <!--                  </tr>-->
      <!--                  <tr>-->
      <!--                    <td v-for="cond in report['campaigns'][0].keyword" :key="cond.id">-->
      <!--                      <span-->
      <!--                        >{{ cond.id }} <br />-->
      <!--                        {{ cond.amount }} |-->
      <!--                        {{ report["campaigns"][0].total_in_time_frame }} |-->
      <!--                        {{-->
      <!--                          (-->
      <!--                            (100 * cond.amount) /-->
      <!--                            report["campaigns"][0].total_in_time_frame-->
      <!--                          ).toFixed(1)-->
      <!--                        }}% |-->
      <!--                        {{-->
      <!--                          ((100 * cond.amount) / report["campaigns"][0].total).toFixed(-->
      <!--                            1-->
      <!--                          )-->
      <!--                        }}% |</span-->
      <!--                      >-->
      <!--                      <span-->
      <!--                        class="report-rank"-->
      <!--                        v-for="rank in cond.rankings"-->
      <!--                        :key="rank"-->
      <!--                        v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--                      >-->
      <!--                        <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--                          {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--                        </span>-->
      <!--                      </span>-->
      <!--                    </td>-->
      <!--                  </tr>-->
      <!--                  <tr>-->
      <!--                    <td-->
      <!--                      v-for="cond in report['campaigns'][0].country_id"-->
      <!--                      :key="cond.id"-->
      <!--                    >-->
      <!--                      <span-->
      <!--                        >{{-->
      <!--                          dictionaries.general.countries.find(-->
      <!--                            country => country.id === cond.id-->
      <!--                          ).name-->
      <!--                        }}-->
      <!--                        <br />-->
      <!--                        {{ cond.amount }} |-->
      <!--                        {{ report["campaigns"][0].total_in_time_frame }} |-->
      <!--                        {{-->
      <!--                          (-->
      <!--                            (100 * cond.amount) /-->
      <!--                            report["campaigns"][0].total_in_time_frame-->
      <!--                          ).toFixed(1)-->
      <!--                        }}% |-->
      <!--                        {{-->
      <!--                          ((100 * cond.amount) / report["campaigns"][0].total).toFixed(-->
      <!--                            1-->
      <!--                          )-->
      <!--                        }}% |</span-->
      <!--                      >-->
      <!--                      <span-->
      <!--                        class="report-rank"-->
      <!--                        v-for="rank in cond.rankings"-->
      <!--                        :key="rank"-->
      <!--                        v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--                      >-->
      <!--                        <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--                          {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--                        </span>-->
      <!--                      </span>-->
      <!--                    </td>-->
      <!--                  </tr>-->
      <!--                </tbody>-->
      <!--              </table>-->
      <!--      </div>-->
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'deposits' &&
            Object.keys(report).length > 0 &&
            report['deposits'] &&
            !Array.isArray(report['deposits']['all_data'][filterOption]) &&
            report['deposits']['all_data'][filterOption]
        "
      >
        <table
          class="daily-stat-data"
          v-if="
            Object.keys(report).length > 0 &&
              !Array.isArray(report['deposits']['all_data'][filterOption]) &&
              report['deposits']['all_data'][filterOption]
          "
        >
          <tbody>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['deposits']['all_data'][filterOption].campaign_aaid
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["deposits"]["all_data"][filterOption]
                      .campaign_aaid[0].id
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption]
                      .campaign_aaid[0].amount
                  }}
                  <!--                  | {{ report["deposits"]['all_data'][filterOption].total_in_time_frame }} |-->
                  {{
                    (
                      (100 *
                        report["deposits"]["all_data"][filterOption]
                          .campaign_aaid[0].amount) /
                      report["deposits"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['deposits']['all_data'][filterOption]
                    .campaign_aaid[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['deposits']['all_data'][filterOption].users
                  ).length > 0
                "
              >
                <span>
                  {{
                    salesPersonList.find(
                      item =>
                        item.id ===
                        report["deposits"]["all_data"][filterOption].users[0].id
                    ).full_name
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption].users[0].amount
                  }}
                  |
                  <!--                  {{ report["deposits"]['all_data'][filterOption].total_in_time_frame }} |-->
                  {{
                    (
                      (100 *
                        report["deposits"]["all_data"][filterOption].users[0]
                          .amount) /
                      report["deposits"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}%
                  <br />
                </span>
                <span
                  class="report-rank"
                  v-for="rank in report['deposits']['all_data'][filterOption]
                    .users[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['deposits']['all_data'][filterOption].country_id
                  ).length > 0
                "
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country =>
                        country.id ===
                        report["deposits"]["all_data"][filterOption]
                          .country_id[0].id
                    ).name
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption].country_id[0]
                      .amount
                  }}
                  |
                  <!--                  {{ report["deposits"]['all_data'][filterOption].total_in_time_frame }} |-->
                  {{
                    (
                      (100 *
                        report["deposits"]["all_data"][filterOption]
                          .country_id[0].amount) /
                      report["deposits"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['deposits']['all_data'][filterOption]
                    .country_id[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['deposits']['all_data'][filterOption].keyword
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["deposits"]["all_data"][filterOption].keyword[0].id
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption].keyword[0]
                      .amount
                  }}
                  |
                  <!--                  {{ report["deposits"]['all_data'][filterOption].total_in_time_frame }} |-->
                  {{
                    (
                      (100 *
                        report["deposits"]["all_data"][filterOption].keyword[0]
                          .amount) /
                      report["deposits"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['deposits']['all_data'][filterOption]
                    .keyword[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--      <div-->
      <!--        class="daily-report-tab"-->
      <!--        v-if="-->
      <!--          selectedStatsTab === 'keywords' &&-->
      <!--            Object.keys(report).length > 0 &&-->
      <!--            report['keywords']['all_data'][filterOption] &&-->
      <!--            report['keywords']['all_data'][filterOption].length > 0-->
      <!--        "-->
      <!--      >-->
      <!--        <span-->
      <!--          v-for="(value, key) in report['keywords']['all_data'][filterOption]"-->
      <!--          :key="key"-->
      <!--          class="top-stat-title"-->
      <!--        >-->
      <!--          {{ report["keywords"]['all_data'][filterOption][key].id }} |-->
      <!--          {{ report["keywords"]['all_data'][filterOption][key].total }} |-->
      <!--          {{ report["keywords"]['all_data'][filterOption][key].total_in_time_frame }} |-->
      <!--          {{-->
      <!--            (-->
      <!--              (100 * report["keywords"]['all_data'][filterOption][key].total) /-->
      <!--              report["keywords"]['all_data'][filterOption][key].total_in_time_frame-->
      <!--            ).toFixed(1)-->
      <!--          }}%-->
      <!--          <br />-->
      <!--          <span-->
      <!--            class="report-rank"-->
      <!--            v-for="rank in report['keywords']['all_data'][filterOption][key].rankings"-->
      <!--            :key="rank"-->
      <!--            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--          >-->
      <!--            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--              {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--            </span>-->
      <!--          </span>-->
      <!--        </span>-->
      <!--              <table-->
      <!--                v-if="-->
      <!--                  Object.keys(report).length > 0 &&-->
      <!--                    report['keywords'] &&-->
      <!--                    report['keywords'].length > 0-->
      <!--                "-->
      <!--              >-->
      <!--                <tbody>-->
      <!--                  <tr>-->
      <!--                    <td v-for="cond in report['keywords'][0].users" :key="cond.id">-->
      <!--                      {{ salesPersonList.find(item => item.id === cond.id).full_name }}-->
      <!--                      <br />-->
      <!--                      {{ cond.amount }} |-->
      <!--                      {{ report["keywords"][0].total_in_time_frame }} |-->
      <!--                      {{-->
      <!--                        (-->
      <!--                          (100 * cond.amount) /-->
      <!--                          report["keywords"][0].total_in_time_frame-->
      <!--                        ).toFixed(1)-->
      <!--                      }}% |-->
      <!--                      {{-->
      <!--                        ((100 * cond.amount) / report["keywords"][0].total).toFixed(1)-->
      <!--                      }}% |-->
      <!--                      <span-->
      <!--                        class="report-rank"-->
      <!--                        v-for="rank in cond.rankings"-->
      <!--                        :key="rank"-->
      <!--                        v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--                      >-->
      <!--                        <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--                          {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--                        </span>-->
      <!--                      </span>-->
      <!--                    </td>-->
      <!--                  </tr>-->
      <!--                  <tr>-->
      <!--                    <td-->
      <!--                      v-for="cond in report['keywords'][0].campaign_aaid"-->
      <!--                      :key="cond.id"-->
      <!--                    >-->
      <!--                      <span-->
      <!--                        >{{ cond.id }} <br />-->
      <!--                        {{ cond.amount }} |-->
      <!--                        {{ report["keywords"][0].total_in_time_frame }} |-->
      <!--                        {{-->
      <!--                          (-->
      <!--                            (100 * cond.amount) /-->
      <!--                            report["keywords"][0].total_in_time_frame-->
      <!--                          ).toFixed(1)-->
      <!--                        }}% |-->
      <!--                        {{-->
      <!--                          ((100 * cond.amount) / report["keywords"][0].total).toFixed(-->
      <!--                            1-->
      <!--                          )-->
      <!--                        }}% |</span-->
      <!--                      >-->
      <!--                      <span-->
      <!--                        class="report-rank"-->
      <!--                        v-for="rank in cond.rankings"-->
      <!--                        :key="rank"-->
      <!--                        v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--                      >-->
      <!--                        <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--                          {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--                        </span>-->
      <!--                      </span>-->
      <!--                    </td>-->
      <!--                  </tr>-->
      <!--                  <tr>-->
      <!--                    <td v-for="cond in report['keywords'][0].country_id" :key="cond.id">-->
      <!--                      <span-->
      <!--                        >{{-->
      <!--                          dictionaries.general.countries.find(-->
      <!--                            country => country.id === cond.id-->
      <!--                          ).name-->
      <!--                        }}-->
      <!--                        <br />-->
      <!--                        {{ cond.amount }} |-->
      <!--                        {{ report["keywords"][0].total_in_time_frame }} |-->
      <!--                        {{-->
      <!--                          (-->
      <!--                            (100 * cond.amount) /-->
      <!--                            report["keywords"][0].total_in_time_frame-->
      <!--                          ).toFixed(1)-->
      <!--                        }}% |-->
      <!--                        {{-->
      <!--                          ((100 * cond.amount) / report["keywords"][0].total).toFixed(-->
      <!--                            1-->
      <!--                          )-->
      <!--                        }}% |</span-->
      <!--                      >-->
      <!--                      <span-->
      <!--                        class="report-rank"-->
      <!--                        v-for="rank in cond.rankings"-->
      <!--                        :key="rank"-->
      <!--                        v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
      <!--                      >-->
      <!--                        <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
      <!--                          {{ rank["id"] }}:{{ rank["rank"] }}|-->
      <!--                        </span>-->
      <!--                      </span>-->
      <!--                    </td>-->
      <!--                  </tr>-->
      <!--                </tbody>-->
      <!--              </table>-->
      <!--      </div>-->
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'no_answer_agents' &&
            Object.keys(report).length > 0 &&
            report['no_answer_agents'] &&
            report['no_answer_agents']['all_data'][filterOption] &&
            report['no_answer_agents']['all_data'][filterOption].length > 0
        "
      >
        <span
          v-for="(value, key) in report['no_answer_agents']['all_data'][
            filterOption
          ].slice(0, 3)"
          :key="key"
          class="top-stat-title"
          v-if="
            salesPersonList.find(
              item =>
                item.id ===
                report['no_answer_agents']['all_data'][filterOption][key].id
            )
          "
        >
          {{
            salesPersonList.find(
              item =>
                item.id ===
                report["no_answer_agents"]["all_data"][filterOption][key].id
            ).full_name
          }}
          |
          {{ report["no_answer_agents"]["all_data"][filterOption][key].total }}
          |
          <!--          {{-->
          <!--            report["no_answer_agents"]['all_data'][filterOption][key].total_in_time_frame-->
          <!--          }}-->
          <!--          |-->
          {{
            (
              (100 *
                report["no_answer_agents"]["all_data"][filterOption][key]
                  .total) /
              report["no_answer_agents"]["all_data"][filterOption][key]
                .total_in_time_frame
            ).toFixed(1)
          }}% <br />
          <span
            class="report-rank"
            v-for="rank in report['no_answer_agents']['all_data'][filterOption][
              key
            ].rankings"
            :key="rank"
            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
          >
            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
              {{ rank["id"] }}:{{ rank["rank"] }}|
            </span>
          </span>
        </span>
        <!--      <table-->
        <!--        v-if="-->
        <!--          Object.keys(report).length > 0 &&-->
        <!--            report['no_answer_agents'] &&-->
        <!--            report['no_answer_agents'].length > 0-->
        <!--        "-->
        <!--      >-->
        <!--        <tbody>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['no_answer_agents'][0].campaign_aaid"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["no_answer_agents"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["no_answer_agents"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["no_answer_agents"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['no_answer_agents'][0].country_id"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{-->
        <!--                  dictionaries.general.countries.find(-->
        <!--                    country => country.id === cond.id-->
        <!--                  ).name-->
        <!--                }}-->
        <!--                <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["no_answer_agents"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["no_answer_agents"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["no_answer_agents"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['no_answer_agents'][0].keyword"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["no_answer_agents"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["no_answer_agents"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["no_answer_agents"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--        </tbody>-->
        <!--      </table>-->
      </div>
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'registrations' &&
            Object.keys(report).length > 0 &&
            report['registrations'] &&
            !Array.isArray(report['registrations']['all_data'][filterOption]) &&
            report['registrations']['all_data'][filterOption]
        "
      >
        <table
          class="daily-stat-data"
          v-if="
            Object.keys(report).length > 0 &&
              !Array.isArray(
                report['registrations']['all_data'][filterOption]
              ) &&
              report['registrations']['all_data'][filterOption]
          "
        >
          <tbody>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['registrations']['all_data'][filterOption]
                      .campaign_aaid
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["registrations"]["all_data"][filterOption]
                      .campaign_aaid[0].id
                  }}
                  |
                  {{
                    report["registrations"]["all_data"][filterOption]
                      .campaign_aaid[0].amount
                  }}
                  |
                  <!--                  {{-->
                  <!--                    report["registrations"]['all_data'][filterOption].total_in_time_frame-->
                  <!--                  }}-->
                  <!--                  |-->
                  {{
                    (
                      (100 *
                        report["registrations"]["all_data"][filterOption]
                          .campaign_aaid[0].amount) /
                      report["registrations"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['registrations']['all_data'][
                    filterOption
                  ].campaign_aaid[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['registrations']['all_data'][filterOption].country_id
                  ).length > 0
                "
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country =>
                        country.id ===
                        report["registrations"]["all_data"][filterOption]
                          .country_id[0].id
                    ).name
                  }}
                  |
                  {{
                    report["registrations"]["all_data"][filterOption]
                      .country_id[0].amount
                  }}
                  |
                  <!--                  {{-->
                  <!--                    report["registrations"]['all_data'][filterOption].total_in_time_frame-->
                  <!--                  }}-->
                  <!--                  |-->
                  {{
                    (
                      (100 *
                        report["registrations"]["all_data"][filterOption]
                          .country_id[0].amount) /
                      report["registrations"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['registrations']['all_data'][
                    filterOption
                  ].country_id[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['registrations']['all_data'][filterOption].keyword
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["registrations"]["all_data"][filterOption].keyword[0]
                      .id
                  }}
                  |
                  {{
                    report["registrations"]["all_data"][filterOption].keyword[0]
                      .amount
                  }}
                  |
                  <!--                  {{-->
                  <!--                    report["registrations"]['all_data'][filterOption].total_in_time_frame-->
                  <!--                  }}-->
                  <!--                  |-->
                  {{
                    (
                      (100 *
                        report["registrations"]["all_data"][filterOption]
                          .keyword[0].amount) /
                      report["registrations"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['registrations']['all_data'][
                    filterOption
                  ].keyword[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'scheduled_call_auto_status' &&
            Object.keys(report).length > 0 &&
            report['scheduled_call_auto_status'] &&
            report['scheduled_call_auto_status']['all_data'][filterOption] &&
            report['scheduled_call_auto_status']['all_data'][filterOption]
              .length > 0
        "
      >
        <span
          v-for="(value, key) in report['scheduled_call_auto_status'][
            filterOption
          ].slice(0, 3)"
          :key="key"
          class="top-stat-title"
        >
          {{
            report["scheduled_call_auto_status"]["all_data"][filterOption][key]
              .status.type
          }}
          |
          {{
            report["scheduled_call_auto_status"]["all_data"][filterOption][key]
              .total
          }}
          |
          <!--          {{-->
          <!--            report["scheduled_call_auto_status"]['all_data'][filterOption][key]-->
          <!--              .total_in_time_frame-->
          <!--          }}-->
          <!--          |-->
          {{
            (
              (100 *
                report["scheduled_call_auto_status"]["all_data"][filterOption][
                  key
                ].total) /
              report["scheduled_call_auto_status"]["all_data"][filterOption][
                key
              ].total_in_time_frame
            ).toFixed(1)
          }}% <br />
          <span
            class="report-rank"
            v-for="rank in report['scheduled_call_auto_status']['all_data'][
              filterOption
            ][key].rankings"
            :key="rank"
            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
          >
            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
              {{ rank["id"] }}:{{ rank["rank"] }}|
            </span>
          </span>
        </span>
        <!--      <table-->
        <!--        v-if="-->
        <!--          Object.keys(report).length > 0 &&-->
        <!--            report['scheduled_call_auto_status'] &&-->
        <!--            report['scheduled_call_auto_status'].length > 0-->
        <!--        "-->
        <!--      >-->
        <!--        <tbody>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['scheduled_call_auto_status'][0]-->
        <!--                .campaign_aaid"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{-->
        <!--                  report["scheduled_call_auto_status"][0].total_in_time_frame-->
        <!--                }}-->
        <!--                |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["scheduled_call_auto_status"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["scheduled_call_auto_status"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['scheduled_call_auto_status'][0].country_id"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{-->
        <!--                  dictionaries.general.countries.find(-->
        <!--                    country => country.id === cond.id-->
        <!--                  ).name-->
        <!--                }}-->
        <!--                <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{-->
        <!--                  report["scheduled_call_auto_status"][0].total_in_time_frame-->
        <!--                }}-->
        <!--                |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["scheduled_call_auto_status"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["scheduled_call_auto_status"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['scheduled_call_auto_status'][0].keyword"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{-->
        <!--                  report["scheduled_call_auto_status"][0].total_in_time_frame-->
        <!--                }}-->
        <!--                |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["scheduled_call_auto_status"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["scheduled_call_auto_status"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['scheduled_call_auto_status'][0].users"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              {{ salesPersonList.find(item => item.id === cond.id).full_name }}-->
        <!--              <br />-->
        <!--              {{ cond.amount }} |-->
        <!--              {{ report["scheduled_call_auto_status"][0].total_in_time_frame }}-->
        <!--              |-->
        <!--              {{-->
        <!--                (-->
        <!--                  (100 * cond.amount) /-->
        <!--                  report["scheduled_call_auto_status"][0].total_in_time_frame-->
        <!--                ).toFixed(1)-->
        <!--              }}% |-->
        <!--              {{-->
        <!--                (-->
        <!--                  (100 * cond.amount) /-->
        <!--                  report["scheduled_call_auto_status"][0].total-->
        <!--                ).toFixed(1)-->
        <!--              }}% |-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--        </tbody>-->
        <!--      </table>-->
      </div>
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'transferred_to' &&
            Object.keys(report).length > 0 &&
            report['transferred_to'] &&
            report['transferred_to']['all_data'][filterOption] &&
            report['transferred_to']['all_data'][filterOption].length > 0
        "
      >
        <span
          v-for="(value, key) in report['transferred_to']['all_data'][
            filterOption
          ].slice(0, 3)"
          :key="key"
          class="top-stat-title"
          v-if="
            salesPersonList.find(
              item =>
                item.id ===
                report['transferred_to']['all_data'][filterOption][key].id
            )
          "
        >
          {{
            salesPersonList.find(
              item =>
                item.id ===
                report["transferred_to"]["all_data"][filterOption][key].id
            ).full_name
          }}
          |
          {{ report["transferred_to"]["all_data"][filterOption][key].total }} |
          <!--          {{ report["transferred_to"]['all_data'][filterOption][key].total_in_time_frame }}-->
          <!--          |-->
          {{
            (
              (100 *
                report["transferred_to"]["all_data"][filterOption][key].total) /
              report["transferred_to"]["all_data"][filterOption][key]
                .total_in_time_frame
            ).toFixed(1)
          }}% <br />
          <span
            class="report-rank"
            v-for="rank in report['transferred_to']['all_data'][filterOption][
              key
            ].rankings"
            :key="rank"
            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
          >
            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
              {{ rank["id"] }}:{{ rank["rank"] }}|
            </span>
          </span>
        </span>
        <!--      <table-->
        <!--        v-if="-->
        <!--          Object.keys(report).length > 0 &&-->
        <!--            report['transferred_to'] &&-->
        <!--            report['transferred_to'].length > 0-->
        <!--        "-->
        <!--      >-->
        <!--        <tbody>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['transferred_to'][0].campaign_aaid"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["transferred_to"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['transferred_to'][0].country_id"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{-->
        <!--                  dictionaries.general.countries.find(-->
        <!--                    country => country.id === cond.id-->
        <!--                  ).name-->
        <!--                }}-->
        <!--                <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["transferred_to"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['transferred_to'][0].keyword"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["transferred_to"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--        </tbody>-->
        <!--      </table>-->
      </div>
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'transferred_to_live' &&
            Object.keys(report).length > 0 &&
            report['transferred_to_live'] &&
            report['transferred_to_live']['all_data'][filterOption] &&
            report['transferred_to_live']['all_data'][filterOption].length > 0
        "
      >
        <span
          v-for="(value, key) in report['transferred_to_live']['all_data'][
            filterOption
          ].slice(0, 3)"
          :key="key"
          class="top-stat-title"
          v-if="
            salesPersonList.find(
              item =>
                item.id ===
                report['transferred_to_live']['all_data'][filterOption][key].id
            )
          "
        >
          {{
            salesPersonList.find(
              item =>
                item.id ===
                report["transferred_to_live"]["all_data"][filterOption][key].id
            ).full_name
          }}
          |
          {{
            report["transferred_to_live"]["all_data"][filterOption][key].total
          }}
          |
          <!--          {{-->
          <!--            report["transferred_to_live"]['all_data'][filterOption][key].total_in_time_frame-->
          <!--          }}-->
          <!--          |-->
          {{
            (
              (100 *
                report["transferred_to_live"]["all_data"][filterOption][key]
                  .total) /
              report["transferred_to_live"]["all_data"][filterOption][key]
                .total_in_time_frame
            ).toFixed(1)
          }}% <br />
          <span
            class="report-rank"
            v-for="rank in report['transferred_to_live']['all_data'][
              filterOption
            ][key].rankings"
            :key="rank"
            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
          >
            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
              {{ rank["id"] }}:{{ rank["rank"] }}|
            </span>
          </span>
        </span>
        <!--      <table-->
        <!--        v-if="-->
        <!--          Object.keys(report).length > 0 &&-->
        <!--            report['transferred_to_live'] &&-->
        <!--            report['transferred_to_live'].length > 0-->
        <!--        "-->
        <!--      >-->
        <!--        <tbody>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['transferred_to_live'][0].campaign_aaid"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["transferred_to_live"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_live"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_live"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['transferred_to_live'][0].country_id"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{-->
        <!--                  dictionaries.general.countries.find(-->
        <!--                    country => country.id === cond.id-->
        <!--                  ).name-->
        <!--                }}-->
        <!--                <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["transferred_to_live"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_live"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_live"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['transferred_to_live'][0].keyword"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["transferred_to_live"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_live"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_live"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--        </tbody>-->
        <!--      </table>-->
      </div>
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'transferred_to_online' &&
            Object.keys(report).length > 0 &&
            report['transferred_to_online'] &&
            report['transferred_to_online']['all_data'][filterOption] &&
            report['transferred_to_online']['all_data'][filterOption].length > 0
        "
      >
        <span
          v-for="(value, key) in report['transferred_to_online']['all_data'][
            filterOption
          ].slice(0, 3)"
          :key="key"
          class="top-stat-title"
          v-if="
            salesPersonList.find(
              item =>
                item.id ===
                report['transferred_to_online']['all_data'][filterOption][key]
                  .id
            )
          "
        >
          {{
            salesPersonList.find(
              item =>
                item.id ===
                report["transferred_to_online"]["all_data"][filterOption][key]
                  .id
            ).full_name
          }}
          |
          {{
            report["transferred_to_online"]["all_data"][filterOption][key].total
          }}
          |
          <!--          {{-->
          <!--            report["transferred_to_online"]['all_data'][filterOption][key]-->
          <!--              .total_in_time_frame-->
          <!--          }}-->
          <!--          |-->
          {{
            (
              (100 *
                report["transferred_to_online"]["all_data"][filterOption][key]
                  .total) /
              report["transferred_to_online"]["all_data"][filterOption][key]
                .total_in_time_frame
            ).toFixed(1)
          }}% <br />
          <span
            class="report-rank"
            v-for="rank in report['transferred_to_online']['all_data'][
              filterOption
            ][key].rankings"
            :key="rank"
            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
          >
            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
              {{ rank["id"] }}:{{ rank["rank"] }}|
            </span>
          </span>
        </span>
        <!--      <table-->
        <!--        v-if="-->
        <!--          Object.keys(report).length > 0 &&-->
        <!--            report['transferred_to_online'] &&-->
        <!--            report['transferred_to_online'].length > 0-->
        <!--        "-->
        <!--      >-->
        <!--        <tbody>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['transferred_to_online'][0].campaign_aaid"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["transferred_to_online"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_online"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_online"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['transferred_to_online'][0].country_id"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{-->
        <!--                  dictionaries.general.countries.find(-->
        <!--                    country => country.id === cond.id-->
        <!--                  ).name-->
        <!--                }}-->
        <!--                <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["transferred_to_online"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_online"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_online"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--          <tr>-->
        <!--            <td-->
        <!--              v-for="cond in report['transferred_to_online'][0].keyword"-->
        <!--              :key="cond.id"-->
        <!--            >-->
        <!--              <span-->
        <!--                >{{ cond.id }} <br />-->
        <!--                {{ cond.amount }} |-->
        <!--                {{ report["transferred_to_online"][0].total_in_time_frame }} |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_online"][0].total_in_time_frame-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * cond.amount) /-->
        <!--                    report["transferred_to_online"][0].total-->
        <!--                  ).toFixed(1)-->
        <!--                }}% |</span-->
        <!--              >-->
        <!--              <span-->
        <!--                class="report-rank"-->
        <!--                v-for="rank in cond.rankings"-->
        <!--                :key="rank"-->
        <!--                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"-->
        <!--              >-->
        <!--                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">-->
        <!--                  {{ rank["id"] }}:{{ rank["rank"] }}|-->
        <!--                </span>-->
        <!--              </span>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--        </tbody>-->
        <!--      </table>-->
      </div>
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'cc_decline_deposits' &&
            Object.keys(report).length > 0 &&
            report['cc_decline_deposits'] &&
            !Array.isArray(
              report['cc_decline_deposits']['all_data'][filterOption]
            ) &&
            report['cc_decline_deposits']['all_data'][filterOption]
        "
      >
        <table
          class="daily-stat-data"
          v-if="
            Object.keys(report).length > 0 &&
              !Array.isArray(
                report['cc_decline_deposits']['all_data'][filterOption]
              ) &&
              report['cc_decline_deposits']['all_data'][filterOption]
          "
        >
          <tbody>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['cc_decline_deposits']['all_data'][filterOption]
                      .campaign_aaid
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .campaign_aaid[0].id
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .campaign_aaid[0].amount
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_clients_in_time_frame
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .campaign_aaid[0].deposits
                  }}
                  |
                  <!--                  {{-->
                  <!--                    report["cc_decline_deposits"]['all_data'][filterOption]-->
                  <!--                      .total_deposits_in_time_frame-->
                  <!--                  }}-->
                  <!--                  |-->
                  {{
                    (
                      (100 *
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .campaign_aaid[0].amount) /
                      report["cc_decline_deposits"]["all_data"][filterOption]
                        .total_clients_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['cc_decline_deposits']['all_data'][
                    filterOption
                  ].campaign_aaid[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['cc_decline_deposits']['all_data'][filterOption]
                      .users
                  ).length > 0
                "
              >
                <span>
                  {{
                    salesPersonList.find(
                      item =>
                        item.id ===
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .users[0].id
                    ).full_name
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .users[0].amount
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_clients_in_time_frame
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .users[0].deposits
                  }}
                  |
                  <!--                  {{-->
                  <!--                    report["cc_decline_deposits"]['all_data'][filterOption]-->
                  <!--                      .total_deposits_in_time_frame-->
                  <!--                  }}-->
                  <!--                  |-->
                  {{
                    (
                      (100 *
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .users[0].amount) /
                      report["cc_decline_deposits"]["all_data"][filterOption]
                        .total_clients_in_time_frame
                    ).toFixed(1)
                  }}% <br />
                </span>
                <span
                  class="report-rank"
                  v-for="rank in report['cc_decline_deposits']['all_data'][
                    filterOption
                  ].users[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['cc_decline_deposits']['all_data'][filterOption]
                      .country_id
                  ).length > 0
                "
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country =>
                        country.id ===
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .country_id[0].id
                    ).name
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .country_id[0].amount
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_clients_in_time_frame
                  }}

                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .country_id[0].deposits
                  }}
                  |
                  <!--                  {{-->
                  <!--                    report["cc_decline_deposits"]['all_data'][filterOption]-->
                  <!--                      .total_deposits_in_time_frame-->
                  <!--                  }}-->
                  <!--                  |-->
                  {{
                    (
                      (100 *
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .country_id[0].amount) /
                      report["cc_decline_deposits"]["all_data"][filterOption]
                        .total_clients_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['cc_decline_deposits']['all_data'][
                    filterOption
                  ].country_id[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['cc_decline_deposits']['all_data'][filterOption]
                      .keyword
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .keyword[0].id
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .keyword[0].amount
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_clients_in_time_frame
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .keyword[0].deposits
                  }}
                  |
                  <!--                  {{-->
                  <!--                    report["cc_decline_deposits"]['all_data'][filterOption]-->
                  <!--                      .total_deposits_in_time_frame-->
                  <!--                  }}-->
                  <!--                  |-->
                  {{
                    (
                      (100 *
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .keyword[0].amount) /
                      report["cc_decline_deposits"]["all_data"][filterOption]
                        .total_clients_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['cc_decline_deposits']['all_data'][
                    filterOption
                  ].keyword[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'not_reached' &&
            Object.keys(report).length > 0 &&
            report['not_reached'] &&
            !Array.isArray(report['not_reached']['all_data'][filterOption]) &&
            report['not_reached']['all_data'][filterOption]
        "
      >
        <table
          class="daily-stat-data"
          v-if="
            Object.keys(report).length > 0 &&
              !Array.isArray(report['not_reached']['all_data'][filterOption]) &&
              report['not_reached']['all_data'][filterOption]
          "
        >
          <tbody>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_reached']['all_data'][filterOption]
                      .campaign_aaid
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["not_reached"]["all_data"][filterOption]
                      .campaign_aaid[0].id
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption]
                      .campaign_aaid[0].amount
                  }}
                  {{
                    (
                      (100 *
                        report["not_reached"]["all_data"][filterOption]
                          .campaign_aaid[0].amount) /
                      report["not_reached"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['not_reached']['all_data'][filterOption]
                    .campaign_aaid[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_reached']['all_data'][filterOption].users
                  ).length > 0
                "
              >
                <span>
                  {{
                    salesPersonList.find(
                      item =>
                        item.id ===
                        report["not_reached"]["all_data"][filterOption].users[0]
                          .id
                    ).full_name
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption].users[0]
                      .amount
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_reached"]["all_data"][filterOption].users[0]
                          .amount) /
                      report["not_reached"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}%
                  <br />
                </span>
                <span
                  class="report-rank"
                  v-for="rank in report['not_reached']['all_data'][filterOption]
                    .users[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_reached']['all_data'][filterOption].country_id
                  ).length > 0
                "
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country =>
                        country.id ===
                        report["not_reached"]["all_data"][filterOption]
                          .country_id[0].id
                    ).name
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption]
                      .country_id[0].amount
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_reached"]["all_data"][filterOption]
                          .country_id[0].amount) /
                      report["not_reached"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['not_reached']['all_data'][filterOption]
                    .country_id[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_reached']['all_data'][filterOption].keyword
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["not_reached"]["all_data"][filterOption].keyword[0]
                      .id
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption].keyword[0]
                      .amount
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_reached"]["all_data"][filterOption]
                          .keyword[0].amount) /
                      report["not_reached"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(1)
                  }}% <br
                /></span>

                <span
                  class="report-rank"
                  v-for="rank in report['not_reached']['all_data'][filterOption]
                    .keyword[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="daily-report-tab"
        v-if="
          selectedStatsTab === 'not_interested_reasons' &&
            Object.keys(report).length > 0 &&
            report['not_interested_reasons'] &&
            report['not_interested_reasons']['all_data'][filterOption] &&
            report['not_interested_reasons']['all_data'][filterOption].length >
              0
        "
      >
        <span
          v-for="(value, key) in report['not_interested_reasons']['all_data'][
            filterOption
          ].slice(0, 3)"
          :key="key"
          class="top-stat-title"
          v-if="
            dictionaries.activity.not_int_states.find(
              item =>
                item.id ===
                report['not_interested_reasons']['all_data'][filterOption][key]
                  .id
            )
          "
        >
          {{
            dictionaries.activity.not_int_states.find(
              item =>
                item.id ===
                report["not_interested_reasons"]["all_data"][filterOption][key]
                  .id
            ).name
          }}
          |
          {{
            report["not_interested_reasons"]["all_data"][filterOption][key]
              .total
          }}
          |
          <!--          {{ report["brokers"]['all_data'][filterOption][key].total_in_time_frame }} |-->
          {{
            (
              (100 *
                report["not_interested_reasons"]["all_data"][filterOption][key]
                  .total) /
              report["not_interested_reasons"]["all_data"][filterOption][key]
                .total_in_time_frame
            ).toFixed(1)
          }}%
          <br />
          <span
            class="report-rank"
            v-for="rank in report['not_interested_reasons']['all_data'][
              filterOption
            ][key].rankings"
            :key="rank"
            v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
          >
            <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
              {{ rank["id"] }}:{{ rank["rank"] }}|
            </span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../helpers/api/request";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "DailyStatsReports.component",
  components: {
    DatePicker
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },

  data() {
    return {
      reportBusy: false,
      filterOption: "REG",
      reportDate: moment().subtract(1, "days"),
      report: [],
      statsTabs: [
        {
          id: 0,
          name: "NEW",
          alias: "registrations"
        },
        {
          id: 1,
          name: "NA",
          alias: "no_answer_agents"
        },
        {
          id: 2,
          name: "SC-AUTO",
          alias: "scheduled_call_auto_status"
        },
        {
          id: 3,
          name: "TRNSF-TOTAL",
          alias: "transferred_to"
        },
        {
          id: 4,
          name: "TRNSF-LIVE",
          alias: "transferred_to_live"
        },
        {
          id: 5,
          name: "TRNSF-ONLINE",
          alias: "transferred_to_online"
        },
        {
          id: 6,
          name: "BROKERS",
          alias: "brokers"
        },
        {
          id: 7,
          name: "DEP",
          alias: "deposits"
        },
        {
          id: 8,
          name: "CC-DECLINE",
          alias: "cc_decline_deposits"
        },
        {
          id: 9,
          name: "NI",
          alias: "not_interested_reasons"
        },
        {
          id: 10,
          name: "NR",
          alias: "not_reached"
        },
        {
          id: 11,
          name: "BN",
          alias: "bad_number_reasons"
        }
      ],
      selectedStatsTab: "registrations"
    };
  },
  created() {
    this.getTimelyReport(1);
  },
  methods: {
    async getTimelyReport(timeFrame) {
      if (
        !this.reportBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.reportBusy = true;
          const res = await apiClientCreator(
            `reports/timely_report/${timeFrame}`
          ).get("");
          this.reportDate = moment(res.data["time_created"]["date"])
            .subtract(1, "days")
            .format("YYYY-MM-DD");
          this.report = res.data["report"];
          this.reportBusy = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    changeFilter(event) {
      this.filterOption = event.target.value;
    },
    async getReportByDate(timeFrame) {
      timeFrame = moment(timeFrame)
        .add(1, "days")
        .format("YYYY-MM-DD");
      if (
        !this.reportBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.reportBusy = true;
          const res = await apiClientCreator(
            `reports/timely_report_by_date/1/${timeFrame}`
          ).get("");
          this.report = res.data;
          this.reportBusy = false;
        } catch (e) {}
      }
    },
    notAfterToday(date) {
      return date > moment().subtract(1, "days");
    },
    getClasses(date) {
      if (
        moment(this.reportDate).format("YYYY-MM-DD") ===
        moment(date).format("YYYY-MM-DD")
      ) {
        return "highlight";
      }
      return "";
    }
  }
};
</script>

<style>
.daily-stat-data {
  width: 100%;
}
.daily-stat-data td {
  vertical-align: top;
  padding: 0 5px 5px 0;
}
.main-tabs {
  min-width: 40%;
  max-height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  background: white;
  flex: 2;
  margin-left: 15px;
  margin-top: -6px;
}

.main-tabs.style2 li {
  max-height: 10%;
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
}

.main-tabs.style2 li:not(:last-child) {
  /*margin-right: 2px;*/
}

.main-tabs li {
  /*max-width: 100%;*/
  /*min-width: 92px;*/
  /*height: 18px;*/
  /*cursor: pointer;*/
  /*background: white;*/
  /*border-radius: 0;*/
  /*text-align: left;*/
  /*vertical-align: middle;*/
  /*line-height: 25px;*/
  /*border-bottom: 2px solid transparent;*/
  /*flex-grow: 2;*/
  /*transition: background 0.2s ease, color 0.2s ease;*/
  font-size: 10px !important;

  max-width: 100%;
  min-width: 92px;
  /*height: 14px;*/
  cursor: pointer;
  background: white;
  border-radius: 0;
  text-align: left;
  vertical-align: middle;
  line-height: 13px;
  border-bottom: 2px solid transparent;
  -webkit-box-flex: 2;
  -ms-flex-positive: 2;
  flex-grow: 2;
  -webkit-transition: background 0.2s ease, color 0.2s ease;
  transition: background 0.2s ease, color 0.2s ease;
}

/*.main-tabs li:not(.empty):hover {*/
/*  transform: translateY(1px);*/
/*}*/

.main-tabs li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}

.main-tabs.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.main-tabs.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.chart-box {
  display: flex;
  background-color: white;
  justify-content: space-between;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
  max-height: 200px;
  min-height: 200px;
}
.negative {
  color: red;
}
.positive {
  color: green;
}
.report-rank {
  font-size: 0.65vw;
}
.daily-report-tab {
  font-size: 0.65vw;
  display: flex;
  flex: 3;
  flex-direction: column;
  justify-content: center;
  padding-left: 70px;
  /*max-width: 50%;*/
}
.daily-stats-tabs {
  display: flex;
  justify-content: space-between;
  font-size: 0.7vw;
}
.stats-tabs-numbers {
}
.top-stat-title {
  padding-bottom: 1em;
}
.filter-buttons {
  display: flex;
  justify-content: center;
}
.filter {
  margin: 0.4em !important;
}
.filter-title {
  margin-bottom: 2px;
  font-weight: bold;
}
.report-options {
  display: flex;
  flex-direction: column;
  font-size: 0.7vw;
}
.report-calendar {
}
.report-data {
  display: flex;
  flex: 1;
  padding: 0.4em;
  /*margin-left: 10px;*/
}
.report-calendar .mx-calendar,
.report-calendar-cm .mx-calendar {
  padding: 0;
}
.report-calendar .mx-datepicker-main,
.report-calendar-cm .mx-datepicker-main {
  border: none;
}
.mx-datepicker-inline {
  border: none !important;
}
.report-calendar-cm .mx-calendar-content {
  height: 120px !important;
}

.report-calendar .mx-calendar-content {
  height: 140px !important;
}
.report-calendar .mx-table-date td,
.mx-table-date th,
.report-calendar-cm .mx-table-date td {
  height: 5px !important;
  font-size: 9px !important;
}
.highlight {
  color: white;
  background: #2a90e9;
}

/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 34%;
  top: 50%;
  font-size: 12px;
}

/*.loader {*/
/*  position: absolute;*/
/*  top: 40%;*/
/*  right: 50%;*/
/*  border: 4px solid #f3f3f3; !* Light grey *!*/
/*  border-top: 4px solid #3498db; !* Blue *!*/
/*  border-radius: 50%;*/
/*  width: 40px;*/
/*  height: 40px;*/
/*  animation: spin 2s linear infinite;*/
/*}*/

/*@keyframes spin {*/
/*  0% {*/
/*    transform: rotate(0deg);*/
/*  }*/
/*  100% {*/
/*    transform: rotate(360deg);*/
/*  }*/
/*}*/
</style>
